import { theme } from '../../../../styles/theme';
import { IMaxSeatsFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import styled from 'styled-components';
import { assertCondition } from '../../../../utils/types';

interface IProps {
  maxSeats: IMaxSeatsFieldsFragment;
}

const Container = styled.div`
  display: flex;
  justify-content: start;
  align-items: flex-start;
  row-gap: 4px;
  flex-direction: column;
`;

const WarningTitle = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

const WarningDescription = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  > b {
    font-weight: 600;
  }
`;

const CustomSeatsExceedWarning = ({ maxSeats }: IProps) => {
  assertCondition(maxSeats.availableSeats <= 0);
  return (
    <Container>
      <WarningTitle>
        Max seat limit ({maxSeats.maxSeats}) has been exceeded
      </WarningTitle>
      <WarningDescription>
        {/* availableSeats is negative or 0 when maxSeats is exceeded */}
        Please disable <b>{` ${-1 * maxSeats.availableSeats + 1} `}</b>
        users before adding new team members.
      </WarningDescription>
    </Container>
  );
};

export default CustomSeatsExceedWarning;
